module.exports = __webpack_public_path__ + "static/media/nonord-c-5.cda0fa96.mp3";